var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAuthorizationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,27v8.7578125l2-2V27h6.7578125l2-2H10C8.8974609,25,8,25.8974609,8,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8813477,39.8764648l1.4134521-1.4134521C4.5141602,37.9208984,4,37.0205078,4,36V21h18.7578125l2-2H4v-4h24.7578125l2-2 H4v-1c0-1.6542969,1.3457031-3,3-3h27.7578125l2-2H7c-2.7568359,0-5,2.2431641-5,5v1v8v15 C2,37.5716553,2.7437134,38.9592285,3.8813477,39.8764648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1186523,8.1235352l-1.4134521,1.4134521C43.4858398,10.0791016,44,10.9794922,44,12v1h-4.7578125l-2,2H44v4H33.2421875 l-2,2H44v15c0,1.6542969-1.3457031,3-3,3H13.2421875l-2,2H41c2.7568359,0,5-2.2431641,5-5V21v-8v-1 C46,10.4283447,45.2562866,9.0407715,44.1186523,8.1235352z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,25 27.2421875,25 25.2421875,27 40,27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.1126986,
    y: 23.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -9.9411259 24)",
    width: 62.2253952,
    height: 1.9997864
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAuthorizationMedium);
export default __webpack_public_path__ + "static/media/no-authorization--medium.714dbbd945ec48ec97b31a2362f43cca.svg";
export { ForwardRef as ReactComponent };